import ValidationConstant from "../../../../../services/validator/validation.constant";

const EquipmentFormConfig = {
    config: {
        description: {
            required: { name: ValidationConstant.equipment.add.description.name },
            maxlength: {
                name: ValidationConstant.equipment.add.description.name,
                max: ValidationConstant.equipment.add.description.maxLength.toString()
            },
            minlength: {
                name: ValidationConstant.equipment.add.description.name,
                min: ValidationConstant.equipment.add.description.minLength.toString()
            },
        },
        equipmentTypeId: {
            required: { name: ValidationConstant.equipment.add.equipmentTypeId.name }
        }
    }
};

export default EquipmentFormConfig;